module.exports = {
  schema: {
    name: '業務區域資料',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        name: '區域代碼',
      },
      name: {
        type: 'String',
        name: '區域名稱',
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key' },
        { key: 'name' },
      ],
    },
    editor: {
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'key' }],
            [{ key: 'name' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/salesRegions.js